'use strict';
window.uomedia = window.uomedia || {};

(($) => {
  const $carousel = $('.carousel');
  if ($carousel.length) {
    $carousel.slick({
      lazyLoad: 'ondemand',
      adaptiveHeight: true
    });
  }
})(jQuery);
